import { Avatar } from "@/components/ui/Avatar";
import { memoUserToAvatar } from "@/lib/memoAvatar";
import { t } from "@/lib/strings";
import type { MemoUser } from "@/lib/types";

/**
 * Who is on the roster — read-only.
 *
 * Shared by the two places that show one: a MEMO's attendance (who was in that meeting) and
 * a SERIES' default participants (who is normally in the room). Both chips used to be inert
 * decoration — they rendered "10 Teilnehmer" and did nothing, so they looked clickable and
 * weren't. Same bug, twice, and they are fixed with one list so they cannot drift into
 * rendering the same person two different ways.
 */
export function ParticipantList({ people }: { people: MemoUser[] }) {
  if (people.length === 0) {
    return (
      <p style={{ margin: 0, fontSize: 13, color: "var(--ink-3)" }}>{t.memoParticipantsNone}</p>
    );
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {people.map((u) => (
        <div
          key={u.id}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "7px 2px",
            fontSize: 13.5,
            color: "var(--ink-1)",
          }}
        >
          <Avatar user={memoUserToAvatar(u)} size={24} />
          {u.display_name ?? u.username ?? "?"}
        </div>
      ))}
    </div>
  );
}
